function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#BUSD_svg__clip0_1_160)",
  fill: "#F0B90B",
  stroke: "#F0B90B",
  strokeWidth: 0.074
}, /*#__PURE__*/React.createElement("path", {
  d: "M15 .063l3.69 3.779-9.292 9.29-3.69-3.689L15 .063zM20.6 5.664l3.69 3.78L9.399 24.334l-3.69-3.69 14.893-14.98zM3.797 11.266l3.69 3.778-3.69 3.69-3.69-3.69 3.69-3.778zM26.202 11.266l3.69 3.778-14.893 14.893-3.69-3.69 14.893-14.981z"
}));

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "BUSD_svg__clip0_1_160"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h30v30H0z"
})));

function SvgBusd(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    fill: "none"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "d41342f52b15734b73e98c4b5027fd28.svg";
export { SvgBusd as ReactComponent };